import { render } from "./App.vue?vue&type=template&id=54fe60e7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=54fe60e7&lang=css"

import exportComponent from "/home/devops/vsts-agent/_work/20/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__